module.exports = __webpack_public_path__ + "static/Laptop_SF-dcccea5b402f59407071380b02aaff55.mp4";